import Vue from "vue";

Vue.mixin({
  methods: {
    getLatLng(coordinates) {
      if (Array.isArray(coordinates)) {
        return { lng: coordinates[0], lat: coordinates[1] };
      } else {
        return [coordinates.lng, coordinates.lat];
      }
    }
  }
});
